/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    // Label,
    // FormGroup,
    Row,
    // Label,
    Input,
    Button,
    // Table,
    // Form,
    // Badge,
    // Input,
    CardHeader,
    CardFooter,
    Col,
    Container,
} from "reactstrap";
import axios from "axios";
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile";
import { Link, useHistory } from "react-router-dom";
import CurrencyInput from 'react-currency-input-field';
import SweetAlert from "react-bootstrap-sweetalert";

// import { MapContainer, TileLayer, Marker } from 'react-leaflet';
// import "leaflet/dist/leaflet.css";
// import L from "leaflet";
// import markerIconPng from "leaflet/dist/images/marker-icon.png";

// Fix default marker agar muncul
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//     iconUrl: require("leaflet/dist/images/marker-icon.png"),
//     iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
//     shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// });

export default function PenawaranDokumenCanvaser(props) {
    const warehouse = localStorage.warehouse;
    const token = localStorage.token;
    const username = localStorage.username;
    const [description, setDescription] = useState("");
    const [long, setLong] = useState(0);
    const [lat, setLat] = useState(0);
    const [alamat, setAlamat] = useState("");
    const [email, setEmail] = useState("");
    const [whatsapp, setWhatsapp] = useState("");
    const [namaproyek, setNamaProyek] = useState("");
    const [namacustomer, setNamaCustomer] = useState("");
    const [savedItems, setSavedItems] = useState([]);
    const [uomConversions, setUomConversions] = useState({});
    const [customer, setCustomer] = useState("");
    const [totalPrice, setTotalPrice] = useState(0);
    const [isSearchShoww, setIsSearchShoww] = useState(false);
    const [allItemm, setAllItemm] = useState([]);
    const [queryy, setQueryy] = useState("");
    const headers = { Authorization: `Bearer ${token}` };
    const [totaldiskon, setTotalDiskon] = useState(0);
    const [grandtotal, setGrandTotal] = useState(0);
    const [tanggal, setTanggal] = useState("");
    let history = useHistory();

    const [loadings, setLoadings] = useState(false)

    const [diskonglobalnominal, setDiskonGlobalNominal] = useState(0);
    const [diskonglobalpersen, setDiskonGlobalPersen] = useState(0);
    const [ongkir1, setOngkir1] = useState(0);
    const [ppnnew, setPPNNEW] = useState(0);
    const [totalPrice1, setTotalPrice1] = useState(0);
    const a = useState(0);
    const [diskonglobalnominal1, setDiskonGlobalNominal1] = useState(0)
    const [totaldiskon2, setTotalDiskon2] = useState(0);
    const [qtyTotal, setTotalQty] = useState(0);
    const [diskontotal, setDiskonTotal] = useState(0);
    const [alert, setAlert] = React.useState(null);
    const [kodecanvasing, setKodeCanvasing] = useState("");

    useEffect(() => {
        getById();
    }, []);

    const getById = () => {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/canvasing/get?code=${props.match.params.code}`, { headers })
            .then((data) => {
                const res = data.data.response;
                const lat = parseFloat(res.latitude_proyek);
                const lng = parseFloat(res.longitude_proyek);
                setKodeCanvasing(res.canvasing_code);
                setDescription(res.keterangan_canvasing);
                setAlamat(res.manual_alamat_proyek);
                setCustomer(res.customer_id);
                setNamaCustomer(res.customer_name);
                setNamaProyek(res.nama_proyek);
                setWhatsapp(res.customer_phone);
                setEmail(res.customer_email);
                setTanggal(res.created_at)
                setLat(lat);
                setLong(lng);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        const getData = setTimeout(async () => {
            if (queryy != '') {
                axios
                    .post(`${process.env.REACT_APP_API_BASE_URL}/items-so-proyek`, { item_info: queryy, page: 1, per_page: 10, warehouse_id: parseInt(warehouse) }, { headers })
                    .then((res) => {
                        setAllItemm(res.data);
                        setIsSearchShoww(true);
                    })
                    .catch(function (error) {
                        setGagalAlert(error.response.data.message);
                    });
            } else {
                setAllItemm(null);
            }
        }, 1000)
        return () => clearTimeout(getData)
    }, [queryy]);

    useEffect(() => {
        setDiskonGlobalNominal1(diskonglobalnominal);
    }, [diskonglobalnominal]);

    // diskon bayangan
    useEffect(() => {
        setTotalDiskon(diskonglobalnominal1);
    }, [diskonglobalnominal1]);

    //diskon tampil
    useEffect(() => {
        setTotalDiskon2((totaldiskon));
    }, [totaldiskon]);

    //ongkir tampil
    useEffect(() => {
        setOngkir1(0);
    }, []);

    useEffect(() => {
        setTotalPrice1((qtyTotal));
    }, [qtyTotal]);


    // diskonglobalnominal dan persen
    useEffect(() => {
        diskonglobalnominal === "diskonglobalnominal" && setDiskonGlobalPersen((diskonglobalnominal / qtyTotal) * 100);
        diskonglobalpersen === "diskonglobalpersen" && setDiskonGlobalNominal((qtyTotal) * (diskonglobalpersen / 100));
    }, [diskonglobalnominal, qtyTotal, diskonglobalpersen, diskontotal, diskonglobalpersen]);

    // hasil nominal dari PPN
    useEffect(() => {
        setPPNNEW((qtyTotal - totaldiskon) - ((qtyTotal - totaldiskon)));
    }, [qtyTotal, totaldiskon]);

    // hasil grandtotal
    useEffect(() => {
        setGrandTotal((totalPrice1 - totaldiskon2) + ppnnew - a);
    }, [totalPrice1, qtyTotal, totaldiskon2, ppnnew, a]);

    const handleEditNote = (index, value) => {
        let updatedList = [...savedItems];
        const item = { ...updatedList[index] };
        // Update note, izinkan string kosong ("")
        item.note = value !== undefined ? value : "";
        updatedList[index] = item;
        setSavedItems(updatedList);
    };

    const handleEditDiskonPersen = (index, value) => {
        const updatedList = [...savedItems];
        const item = { ...updatedList[index] };

        // Jika kosong, reset semua
        if (!value || value.trim() === "") {
            item.diskon_persen = 0;         // Tetap string kosong
            item.diskon_nominal = 0;
        } else if (value.includes("+")) {
            const { diskonNominal } = calculateTieredDiscount(item.harga, value);
            item.diskon_persen = value;      // Simpan "10+10"
            item.diskon_nominal = diskonNominal;
        } else {
            const numericValue = parseFloat(value);
            const diskonNominal = (item.harga * (isNaN(numericValue) ? 0 : numericValue)) / 100;

            item.diskon_persen = value;      // Tetap simpan "20" (string)
            item.diskon_nominal = diskonNominal;
        }

        updatedList[index] = item;
        setSavedItems(updatedList);
        recalculateTotals(updatedList);
    };

    const calculateTieredDiscount = (harga, diskonBertingkat) => {
        if (!harga || isNaN(harga) || !diskonBertingkat) {
            return { diskonNominal: 0 };
        }

        const diskonArray = diskonBertingkat
            .toString()
            .split("+")
            .map((d) => parseFloat(d.trim()))
            .filter((d) => !isNaN(d));

        let sisaHarga = harga;
        let totalDiskonNominal = 0;

        diskonArray.forEach((persen) => {
            const potongan = sisaHarga * (persen / 100);
            totalDiskonNominal += potongan;
            sisaHarga -= potongan;
        });

        return {
            diskonNominal: parseFloat(totalDiskonNominal.toFixed(0)), // Bulatkan ke bawah
        };
    };



    const handleEditHarga = (index, value) => {
        const numericValue = parseCurrency(value);
        if (isNaN(numericValue)) return;

        let updatedList = [...savedItems];
        const item = { ...updatedList[index] };
        item.harga = numericValue;

        // Jika ada diskon persen, update juga diskon nominal
        if (item.diskon_persen) {
            const { diskonNominal } = calculateTieredDiscount(numericValue, item.diskon_persen.toString());
            item.diskon_nominal = diskonNominal;
        }

        updatedList[index] = item;
        setSavedItems(updatedList);
        recalculateTotals(updatedList);
    };

    // Fungsi untuk menangani input qty
    const handleEditQty = (index, value) => {
        const numericValue = parseCurrency(value);
        if (isNaN(numericValue)) return;

        let updatedList = [...savedItems];
        const item = { ...updatedList[index] };
        item.qty = numericValue;

        updatedList[index] = item;
        setSavedItems(updatedList);
        recalculateTotals(updatedList);
    };


    // Fungsi untuk menangani input diskon nominal
    const handleEditDiskonNominal = (index, value) => {
        const numericValue = parseCurrency(value);
        if (isNaN(numericValue)) return;

        let updatedList = [...savedItems];
        const item = { ...updatedList[index] };
        item.diskon_nominal = numericValue;

        // Update diskon persen jika harga tersedia
        if (item.harga && item.harga > 0) {
            item.diskon_persen = (numericValue / item.harga) * 100;
        }

        updatedList[index] = item;
        setSavedItems(updatedList);
        recalculateTotals(updatedList);
    };

    const recalculateTotals = (items = savedItems) => {
        let total = 0;
        let diskonTotal = 0;

        items.forEach(item => {
            const harga = parseFloat(item.harga) || 0;
            const diskonNominal = parseFloat(item.diskon_nominal) || 0;
            const qty = parseFloat(item.qty) || 0;

            total += (harga - diskonNominal) * qty;
            diskonTotal += diskonNominal * qty;
        });

        setTotalQty(total);         // Total Harga - Diskon
        setDiskonTotal(diskonTotal); // Total Diskon Nominal
    };

    useEffect(() => {
        recalculateTotals();
    }, [savedItems]);


    const parseCurrency = (value) => {
        if (!value && value !== 0) return 0;

        const cleaned = value.toString().replace(/\./g, '').replace(',', '.');
        const parsed = parseFloat(cleaned);
        return isNaN(parsed) ? 0 : parsed;
    };

    const saveItemOrUpdate = async (item) => {
        const existingItem = savedItems.find((i) => i.item_id === item.id);

        if (!existingItem) {
            // Jika item memiliki konversi satuan, panggil API untuk mendapatkan UOM
            // if (item.total_uom_conversions > 0) {
            await fetchUomConversions(item.id);
            // }

            const newItem = {
                image_url: item.image_url || "",
                item_id: item.id,
                item_name: item.item_name,
                item_code: item.item_code,
                qtysisa: item.stock,
                satuan: item.satuan, // Default satuan
                barcode: item.barcode,
                qty: 1,
                harga: item.price || 0,
                uom_id: item.uom_id || 0,
                uom_conversion_id: item.uom_conversion_id || 0,
                diskon_nominal: item.diskon_nominal || 0,
                diskon_persen: item.diskon_persen || 0,
                is_konsinyasi: item.is_konsinyasi || 0,
                total_uom_conversions: item.total_uom_conversions,
            };
            setSavedItems([...savedItems, newItem]);
        } else {
            const updatedList = [...savedItems];
            const index = updatedList.findIndex((i) => i.item_id === item.id);
            updatedList[index].qty += 1;
            setSavedItems(updatedList);
        }
        recalculateTotals();
    };

    const fetchUomConversions = async (itemId) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/items/uom-all/${itemId}?active_flag=1&warehouse_id=${warehouse}`,
                { headers }
            );
            setUomConversions((prev) => ({
                ...prev,
                [itemId]: response.data.response, // Simpan data UOM untuk item tertentu
            }));
        } catch (error) {
            console.error("Error fetching UOM conversions:", error);
        }
    };

    const deleteItem = (id) => {
        let array = [...savedItems];

        let index = array.findIndex(object => {
            return object.item_id === id;
        });

        if (index !== -1) {
            setTotalPrice(totalPrice - (array[index].harga - array[index].diskon_nominal) * array[index].qty);
            setTotalQty(qtyTotal - (array[index].harga - array[index].diskon_nominal) * array[index].qty);
            setDiskonTotal(diskontotal - array[index].diskon_nominal * array[index].qty);
            array.splice(index, 1);
            setSavedItems(array);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        {
            setQueryy("");
            setIsSearchShoww("");
            return true
        }
    };


    // const getById = () => {
    //     const headers = {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${token}`,
    //     };
    //     axios
    //         .get(`${process.env.REACT_APP_API_BASE_URL}/canvasing/get?code=${props.match.params.code}`, { headers })
    //         .then(async (data) => {
    //             const res = data.data.response;
    //             setDescription(res.keterangan);
    //             setImage1(res.foto1);
    //             setImage2(res.foto2);
    //             setImage3(res.foto3);
    //             setImage4(res.foto4);
    //             setImage5(res.foto5);
    //             setLong(res.longitude_proyek);
    //             setLat(res.latitude_proyek);
    //             setAlamat(res.manual_alamat_proyek);
    //             setAlamatOtomatis(res.alamat_proyek);
    //             setNamaCustomer(res.customer_name);
    //             setNamaProyek(res.nama_proyek);
    //             setWhatsapp(res.phone);
    //             setEmail(res.email);
    //             // await onLoadMaps(res.latitude_proyek, res.longitude_proyek)
    //             setMapCenter({ lat: res.latitude_proyek, lng: res.longitude_proyek });

    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // };

    // useEffect(() => {
    //     if (lat && long) {
    //         onLoadMaps(lat, long); // Update map center based on new lat/lng
    //     }
    // }, [lat, long]); // Dependency array - runs when lat or long change

    // const onLoadMaps = async (lats, longs) => {
    //     // console.log("Latitude:", lats, "Longitude:", longs);
    //     if (onmap) {
    //         const bounds = new L.LatLngBounds(
    //             new L.LatLng(lats, longs)
    //         );
    //         onmap.fitBounds(bounds);
    //     }
    //     if (onmap) {
    //         onmap.setZoom(14); // Set a default zoom level
    //     }
    // };

    // const apiIsLoaded = (map) => {
    //     console.log("Map instance loaded:", map);
    //     setOnmap(map);
    // };
    const formatRupiah = (money) => {
        return new Intl.NumberFormat('id-ID',
            { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
        ).format(money);
    }

    const handleSubmit1 = () => {
        hideAlert();
        setLoadings(true)
        setTimeout(() => { CreateData() }, 1000);
    };

    function CreateData() {
        setLoadings(true)
        let dataItems = [];
        savedItems.map((dataItem) => dataItems = [...dataItems,
        {
            item_id: dataItem.item_id,
            qty: dataItem.qty,
            harga: dataItem.harga,
            diskon_nominal: dataItem.diskon_nominal,
            diskon_persen: dataItem.diskon_persen,
            note: dataItem.note,
            is_konsinyasi: dataItem.is_konsinyasi,
            uom_id: dataItem.uom_id,
            uom_conversion_id: dataItem.uom_conversion_id,
        }]);
        let data = {
            warehouse_id: parseInt(warehouse),
            username: username,
            customer_id: parseInt(customer),
            type: 1,
            pajak_id: 1,
            status_rfq: 3,
            status: 3,
            canvasing_code: kodecanvasing,
            // pengiriman : parseInt(pengiriman),
            keterangan: description,
            manual_address: alamat,
            diskon_global_nominal: diskonglobalnominal,
            diskon_global_persen: diskonglobalpersen,
            ongkir: 0,
            items: dataItems
        };
        axios
            .post(
                `${process.env.REACT_APP_API_BASE_URL}/rfq-so/save-canvas`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            .then(function (response) {
                setSuccessAlert(response.data.message);
                setLoadings(false)
                setTimeout(() => (history.push("/mobile/sales/page")), 1000);

            })
            .catch(function (error) {
                setLoadings(false)
                setGagalAlert(error.response.data.message);
            });
    }

    const setSuccessAlert = (id) => {
        setAlert(
            <SweetAlert
                success
                showConfirm
                confirmBtnText="Ok"
                title={id}
                timeout={1000}
                onCancel={hideAlert}
                onConfirm={hideAlert}
            />
        )
    }

    const setGagalAlert = (id) => {
        setAlert(
            <SweetAlert
                danger
                showConfirm
                confirmBtnText="Ok"
                title={id}
                onCancel={hideAlert}
                onConfirm={hideAlert}
            />
        );
    };

    const setQuestionAlert = () => {
        setAlert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Lanjutkan"
                confirmBtnBsStyle="danger"
                title="Apakah Kamu Yakin?"
                onConfirm={handleSubmit1}
                onCancel={hideAlert}
                focusCancelBtn
            />
        );
    };

    const hideAlert = () => {
        setAlert(null);
    };

    return (
        <>
            {alert}
            <div>
                <SimpleHeaderMobile to="/mobile/sales/page" />
                <Container className="mt--6" fluid>
                    {lat && long ? (
                        <>
                            {/* <Card className="shadow mb-4">
                                <CardHeader>
                                    <h5 className="mb-0">Lokasi Proyek</h5>
                                </CardHeader>
                                <CardBody>
                                    <div style={{ height: "300px", width: "100%" }}>


                                        <p className="text-center">Loading lokasi proyek...</p>
                                    </div>
                                </CardBody>
                            </Card> */}

                            <Card className="shadow mb-4">
                                <CardHeader className="bg-primary text-white">
                                    <h5 className="mb-0 text-white">📄 Detail Proyek</h5>
                                </CardHeader>
                                <CardBody>
                                    {[
                                        { label: "Tanggal", value: tanggal },

                                        { label: "Proyek", value: namaproyek },
                                        { label: "Customer", value: namacustomer },
                                        { label: "Alamat", value: alamat },
                                        {
                                            label: "WhatsApp", value: whatsapp ? (
                                                <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer">{whatsapp}</a>
                                            ) : "-"
                                        },
                                        // {
                                        //     label: "Email", value: email ? (
                                        //         <a href={`mailto:${email}`}>{email}</a>
                                        //     ) : "-"
                                        // },
                                        { label: "Deskripsi", value: description }
                                    ].map((item, idx) => (
                                        <Row key={idx} className="mb-2">
                                            <Col xs="4" className="font-weight-bold text-sm">{item.label}</Col>
                                            <Col xs="8" className="text-sm">{item.value || "-"}</Col>
                                        </Row>
                                    ))}
                                </CardBody>
                            </Card>

                            <Card className="shadow mb-4">
                                <CardHeader className="bg-success text-white">
                                    <h5 className="mb-0 text-white">🔍 Cari Item</h5>
                                </CardHeader>
                                <CardBody>
                                    <Input
                                        type="text"
                                        placeholder="Ketik nama item..."
                                        value={queryy}
                                        onChange={(e) => setQueryy(e.target.value)}
                                        onFocus={() => setIsSearchShoww(true)}
                                    />
                                    {isSearchShoww && queryy && (
                                        <div className="border rounded mt-2 bg-white shadow-sm" style={{ maxHeight: 250, overflowY: "auto" }}>
                                            {allItemm?.response?.length > 0 ? (
                                                allItemm.response.map((item) => (
                                                    <div
                                                        key={item.id}
                                                        className="d-flex p-2 border-bottom align-items-center"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            saveItemOrUpdate(item);
                                                            setQueryy('');
                                                            setIsSearchShoww(false);
                                                        }}
                                                    >
                                                        <img
                                                            src={item.image_url === "" || item.image_url === " " || item.image_url === null ? require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default : item.image_url}
                                                            alt="-"
                                                            style={{ width: 50, height: 50, objectFit: "cover", borderRadius: 6, marginRight: 10 }}
                                                        />
                                                        <div style={{ flex: 1 }}>
                                                            <div style={{ fontWeight: 'bold' }}>{item.item_name}</div>
                                                            <small className="text-muted">{item.item_code}</small>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="text-center text-danger p-2">Item "{queryy}" tidak ditemukan</div>
                                            )}
                                        </div>
                                    )}
                                </CardBody>
                            </Card>

                            <Card className="shadow mb-4">
                                <CardHeader className="bg-info text-white">
                                    <h5 className="mb-0 text-white">🛒 Item Dipilih</h5>
                                </CardHeader>

                                <CardBody>
                                    {savedItems.length === 0 ? (
                                        <p className="text-center text-muted">Belum ada item ditambahkan</p>
                                    ) : (
                                        savedItems.map((item, index) => {
                                            const subtotal = parseFloat(item.harga || 0) * parseFloat(item.qty || 0);
                                            return (
                                                <div key={index} className="border-bottom pb-2 mb-3">
                                                    <Row>
                                                        <Col xs="3">
                                                            <img
                                                                src={item.image_url === "" || item.image_url === " " || item.image_url === null ? require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default : item.image_url}
                                                                alt="x"
                                                                className="img-fluid rounded"
                                                            />
                                                        </Col>
                                                        <Col xs="9">
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <div>
                                                                    <strong>{item.item_name}</strong>
                                                                    <br />
                                                                    <small className="text-muted">{item.item_code}</small>
                                                                </div>
                                                                <Button close onClick={() => deleteItem(item.item_id)} />
                                                            </div>

                                                            <Row className="mt-2">
                                                                <Col xs="6">
                                                                    <CurrencyInput
                                                                        disabled
                                                                        className="form-control form-control-sm"
                                                                        prefix="Rp "
                                                                        value={item.harga}
                                                                        // onValueChange={(value) => handleEditHarga(index, value)}
                                                                        placeholder="Harga"
                                                                    />
                                                                </Col>
                                                                <Col xs="6">
                                                                    <CurrencyInput
                                                                        className="form-control form-control-sm"
                                                                        value={item.qty}
                                                                        onValueChange={(value) => handleEditQty(index, value)}
                                                                        placeholder="Qty"
                                                                    />

                                                                </Col>
                                                                <Col hidden>
                                                                    {item.is_konsinyasi}
                                                                    {item.uom_conversion_id}
                                                                    {item.uom_id}
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2">
                                                                <Col xs="6">
                                                                    {item.total_uom_conversions > 0 ? (
                                                                        <Input
                                                                            className="form-control form-control-sm"
                                                                            type="select"
                                                                            value={item.uom_id}
                                                                            onChange={(e) => {
                                                                                const updatedList = [...savedItems];
                                                                                const selectedUom = uomConversions[item.item_id]?.find(
                                                                                    (uom) => uom.uom_id.toString() === e.target.value
                                                                                );
                                                                                const newPrice = selectedUom ? selectedUom.price_1 : item.harga;
                                                                                const newUomConversionId = selectedUom ? selectedUom.uom_conversion_id : item.uom_conversion_id;

                                                                                updatedList[index].uom_id = e.target.value;
                                                                                updatedList[index].harga = newPrice;
                                                                                updatedList[index].uom_conversion_id = newUomConversionId;

                                                                                setSavedItems(updatedList);
                                                                                recalculateTotals(updatedList);
                                                                            }}
                                                                        >
                                                                            {uomConversions[item.item_id]?.map((uom, key) => (
                                                                                <option key={key} value={uom.uom_id}>
                                                                                    {uom.uom_description}
                                                                                </option>
                                                                            ))}
                                                                        </Input>
                                                                    ) : (
                                                                        <Input
                                                                            className="form-control form-control-sm"
                                                                            value={item.satuan}
                                                                            disabled
                                                                        />
                                                                    )}
                                                                </Col>
                                                                <Col xs="6">
                                                                    <Input
                                                                        className="form-control form-control-sm bg-light"
                                                                        disabled
                                                                        value={formatRupiah(subtotal)}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            );
                                        })
                                    )}
                                </CardBody>

                                {savedItems.length > 0 && (
                                    <CardFooter>
                                        <Row>
                                            <Col xs="6">
                                                <div><strong>Total</strong></div>
                                                <div><strong>Diskon</strong></div>
                                                <div><strong>PPN</strong></div>
                                                <div><strong>Ongkir</strong></div>
                                                <div className="mt-2 text-success"><strong>Grand Total</strong></div>
                                            </Col>
                                            <Col xs="6" className="text-right">
                                                <div>{formatRupiah(totalPrice1)}</div>
                                                <div>{formatRupiah(totaldiskon2)}</div>
                                                <div>{formatRupiah(ppnnew)}</div>
                                                <div>{formatRupiah(ongkir1)}</div>
                                                <div className="mt-2 text-success"><strong>{formatRupiah(totalPrice1)}</strong></div>
                                            </Col>
                                        </Row>
                                    </CardFooter>
                                )}

                                <CardFooter className="d-flex justify-content-between">
                                    <Link className="btn btn-info" to="/mobile/sales/page">
                                        Kembali
                                    </Link>
                                    <Button disabled={loadings} color="danger" onClick={() => setQuestionAlert()}>
                                        Simpan
                                    </Button>
                                </CardFooter>
                            </Card>


                            {/* {cartItems.length > 0 && (
                                <Card className="shadow mb-5">
                                    <CardHeader className="bg-info text-white">
                                        <h5 className="mb-0 text-white">🛒 Daftar Item</h5>
                                    </CardHeader>
                                    <CardBody>
                                        {cartItems.map((item, idx) => (
                                            <Row key={idx} className="mb-2 align-items-center">
                                                <Col xs="8">{item.name}</Col>
                                                <Col xs="4" className="text-right">
                                                    <Button size="sm" color="danger" onClick={() => removeItem(idx)}>
                                                        Hapus
                                                    </Button>
                                                </Col>
                                            </Row>
                                        ))}
                                    </CardBody>
                                </Card>
                            )} */}

                            {/* <Row className="mt-3">
                                {[1, 2, 3, 4, 5].map((num, index) => (
                                    <Col key={index} xs="6" sm="4" md="2" className="mb-3 text-center">
                                        <label htmlFor={`formId${num}`} style={{ cursor: 'pointer' }}>
                                            <input
                                                hidden
                                                id={`formId${num}`}
                                                name="file"
                                                type="file"
                                                accept="image/*"
                                                onChange={(event) => {
                                                    const file = event.target.files[0];
                                                    if (file) {
                                                        switch (num) {
                                                            case 1: setImage1(file); break;
                                                            case 2: setImage2(file); break;
                                                            case 3: setImage3(file); break;
                                                            case 4: setImage4(file); break;
                                                            case 5: setImage5(file); break;
                                                            default: break;
                                                        }
                                                    }
                                                }}
                                            />
                                            {num === 1 && (
                                                <>
                                                    {image1 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={"require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image1}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                            {num === 2 && (
                                                <>
                                                    {image2 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={"require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image2}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                            {num === 3 && (
                                                <>
                                                    {image3 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={"require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image3}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                            {num === 4 && (
                                                <>
                                                    {image4 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={"require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image4}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                            {num === 5 && (
                                                <>
                                                    {image5 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={"require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image5}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </label>
                                    </Col>
                                ))}
                            </Row> */}

                        </>
                    ) : (
                        <p className="text-center">Loading lokasi proyek...</p>
                    )}
                </Container>
            </div>
        </>
    );
}
